import { z } from 'zod/v4';

// Bare array — no `{data, meta}` envelope, matching the legacy
// `reply.code(200).send(result)` shape the frontend consumers expect.
export const NetworkCountriesResponseSchema = z.array(z.string());

export type NetworkCountriesResponse = z.infer<
  typeof NetworkCountriesResponseSchema
>;
